/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userFirstName",
    label: "Educator's first name",
    fieldRequired: true,
    validation: { required: true }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userLastName",
    label: "Educator's last name",
    fieldRequired: true,
    validation: { required: true }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userPreferredName",
    label: "Educator's preferred first name (optional)",
    hint: "The department will use the preferred first name in any communications."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Educator's date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "userDateOfBirth",
    label: "Date of birth",
    hint: "For example, 31 3 2015",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userEmail",
    type: "email",
    label: "Educator's personal email address",
    hint: "This should be a personal (not shared) email address. This must be an email only the educator uses, not one shared by multiple people.",
    fieldRequired: true,
    validation: { required: true, email: true }
  },
  {
    fieldType: FIELD.INPUT.TEXTCONFIRMATION,
    name: "userEmailConfirmation",
    label: "Educator's email address",
    comparisonGetter: "getEducatorEmail",
    fieldRequired: true,
    validation: { required: true, email: true, confirmed: 'comparisonField' }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "userMobile",
    label: "Mobile number (optional)",
    hint: "Enter your personal (not shared) mobile number. This may be used to recover your account details."
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmUserConsent",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: " I have obtained the educator’s consent to create a NSW Department of Education account on their behalf, and to share their personal information for this purpose."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmUserWwcc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm the educator has a valid and current Working with Children Check."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmUserEmployee",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: "I confirm this person is employed at my service and authorised to access information saved in the Self-Assessment and Quality Improvement Planning Portal platform."
      }
    ]
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "confirmInfoProvided",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: true,
        text: " I declare that the information I have provided in this form is complete and correct and I understand that giving false or misleading information is a serious offence."
      }
    ]
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Create educator account",
        size: "large",
        appearance: "primary",
        action: "form:next"
      }
    ]
  }
];
